module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerb1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Also from the Emerging Civil War 10th Anniversary Series …")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0002-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "capc"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Civil War Monuments and Memory")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Civil War in Pop Culture")]), _vm._v(" make perfect companion volumes. We hope you’ll read the books in conversation with each other for a fuller understanding of the ways that history and historical memory interrelate.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f5c595f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Adcard1.vue
// module id = 60
// module chunks = 0